export default __webpack_public_path__ + "static/media/lascasKlein.a1fb5927.jpg";